// src/composables/useRouteCache.js
import { useRouteCacheStore } from '@/store/routeCache'

export function useRouteCache() {
  const routeCacheStore = useRouteCacheStore()
  
  // 直接返回存储中的方法，保持接口一致
  return {
    getCacheKey: routeCacheStore.getCacheKey,
    refreshCache: routeCacheStore.refreshCache,
    cacheMap: routeCacheStore.cacheMap
  }
}